import styled from 'styled-components';

import { spacing16, spacing8 } from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';
import {
  grey1,
  grey2,
  grey3,
  grey5,
  grey6,
  grey9,
  grey10,
} from 'approot/shared/styles/colours.style';
import {
  baseBoxShadowFocus,
  standardInsetBoxShadow,
} from 'approot/shared/styles/borders.style';

export const RichtextInlineToolbar = styled.div`
  position: absolute;
  top: ${rem(spacing16)};
  left: ${rem(spacing16)};
  z-index: 1;
`;

type RichtextIconButtonProps = {
  $selected?: boolean;
};

export const RichtextIconButton = styled.button.attrs<RichtextIconButtonProps>(
  ({ $selected }) =>
    $selected !== undefined
      ? {
          role: 'checkbox',
          'aria-checked': $selected,
        }
      : {}
)<RichtextIconButtonProps>`
  width: ${rem(32)};
  height: ${rem(32)};
  min-width: auto;
  margin-right: ${rem(spacing8)};
  background-color: ${grey1};
  border-radius: ${rem(32)};
  border: 1px solid ${grey5};
  border-color: ${grey5};
  color: ${grey9};
  cursor: pointer;
  display: inline-block;
  text-align: center;

  &:hover {
    border: 1px solid ${grey9};
    background-color: ${grey2};
  }

  &:hover,
  &:focus {
    text-decoration: none;
  }

  &:focus {
    border-color: ${grey1};
    box-shadow: ${baseBoxShadowFocus};
    outline: 0;
  }

  &:active {
    ${standardInsetBoxShadow}
    border: 1px solid ${grey9};
  }

  &:disabled,
  &.disabled {
    background-color: ${grey3} !important;
    border-color: ${grey5} !important;
    box-shadow: none !important;
    cursor: not-allowed !important;
    color: ${grey6} !important;
  }

  ${({ $selected }) =>
    $selected &&
    `  
      color: ${grey10};
      border: 1px solid ${grey10};
      background-color: ${grey2};

      svg {
        stroke: ${grey10};
        
        path {          
          stroke-width: ${rem(2)};
        }
      }

      &:hover {
        color: ${grey10};
        border: 1px solid ${grey10};
        background-color: ${grey2};
      }
  `}
`;
